/**
 * Client reviews on the home page. Kept here, not in the CMS (Website → home page → clientReviews, no longer read):
 * they rarely change, and from the code they are in the prerendered HTML.
 */
export const CLIENT_REVIEWS: ComponentUiReview[] = [
  {
    id: "7",
    clientName: "Christene Fick (Herotel)",
    feedbackDate: "2025-09-12",
    rate: 5,
    title: "An organized and user-friendly platform",
    content:
      "The Eastech system has been an excellent tool in streamlining our daily operations. It has made managing incoming email requests, particularly those related to wayleave inquiries, far more efficient. What previously required significant manual effort is now handled quickly and seamlessly, saving both time and resources.\n\nThe system provides an organized and user-friendly platform that simplifies responses, reduces turnaround time, and ensures consistency in communication. Overall, it has greatly improved my workflow and has become an invaluable part of our process.",
  },
  {
    id: "8",
    clientName: "Annette Swart (Herotel)",
    feedbackDate: "2025-09-12",
    rate: 5,
    title: "Easetech makes my life easier",
    content:
      "Using the Easetech incoming wayleave management tool has transformed my daily work schedule. It has removed all my admin intensive work and freed up my time to focus on other important tasks. \n\nI am extremely satisfied with their solution and cannot recommend it enough. ",
  },
  {
    id: "1",
    clientName: "Kyle Sinclair",
    feedbackDate: "2024-05-07",
    rate: 5,
    title: "Simple professional process",
    content:
      "I was able to create and submit an application in less than 5 minutes. My wayleaves were then finalised in 2 weeks. Very happy with the simplicity and speed of the process. ",
  },
  {
    id: "2",
    clientName: "Willie Odendaal",
    feedbackDate: "2024-04-04",
    rate: 5,
    title: "Transparent process",
    content:
      "We knew exactly what was happening with our project at each step of the way and we received real time updates as our wayleave approvals came in. The support was also great. ",
  },
  {
    id: "4",
    clientName: "Jacques Potgieter",
    feedbackDate: "2024-04-23",
    rate: 5,
    title: "Hassle free",
    content:
      "I created an application on the system and it told me exactly who and what infrastructure was affected. We were then able to track the progress throughout the project. Really easy process and highly recommended for anyone needing to procure wayleaves. ",
  },
  {
    id: "6",
    clientName: "Edith Kumalo",
    feedbackDate: "2024-05-10",
    rate: 4.5,
    title: "Easy process and support",
    content:
      "Submitting an application on their system was easy and intuitive. I received a quote within a few hours. The support team assisted me throughout the process and were available whenever I had questions. Very satisfied with the service received.",
  },
]
